<template>
	<div>
		<v-row>
			<v-col cols="12" lg="12" md="12">
				<s-crud
					title="Proyecciones"
                    @add="addProjection($event)"
					add
					edit
					remove
                    search-input
					:config="config"
                    @rowSelected="rowSelected($event)"
					@save="save($event)"
					:filter="filter"
                    ref="crudProjections"
				>
					<template v-slot="props">
						<v-container class="">
							<v-row>
								<v-col cols="2" class="s-col-form">
									<s-search-lot-by-cod-senasa
                                        @searchSenasa="lot => updateLotInfo(props.item, lot)"
                                    />
								</v-col>
								<v-col cols="2" class="s-col-form">
									<s-text
                                        readonly
                                        label="ID Lote"
                                        v-model="props.item.FltID">
                                    </s-text>
								</v-col>
								<v-col cols="2" class="s-col-form">
									<s-text
                                        readonly
                                        label="Lote"
                                        v-model="props.item.FltName">
                                    </s-text>
								</v-col>
                                <v-col cols="2" class="s-col-form">
									<s-text
                                        readonly
                                        label="Hectareje"
                                        v-model="props.item.FltHectares">
                                    </s-text>
								</v-col>
								<v-col cols="4" class="s-col-form">
									<s-text
                                        readonly
                                        label="Nombre de Fundo"
                                        v-model="props.item.FagName">
                                    </s-text>
								</v-col>
                                <v-col cols="2" class="s-col-form">
									<s-text
                                        readonly
                                        label="Productor"
                                        v-model="props.item.PrdCardName">
                                    </s-text>
								</v-col>
                                <v-col cols="2" class="s-col-form">
                                    <s-select label="Año" :items="years" outlined hide-details dense v-model="year"></s-select>
                                </v-col>
                                <v-col cols="2" class="s-col-form">
                                    <s-periods label="Periodo Semana" v-model="week" :year="year" :type="1"></s-periods>
                                </v-col>
                                <v-col cols="2" class="s-col-form">
                                    <s-select-Campaign
                                        label="Campaña"
                                        v-model="props.item.CmpID"
                                    />
                                </v-col>
                                <v-col cols="4" class="s-col-form">
                                    <s-select-supervice
                                    clearable
                                    label="Supervisor"
                                    v-model="props.item.NtpSuperviceID"
                                    :value="props.item.NtpSuperviceID"
                                    full /> 
                                </v-col>
                                <v-col cols="2" class="s-col-form">
                                    <s-text
                                        label="Cantidad Jabas"
                                        v-model="props.item.PjtQuantity">
                                    </s-text>
                                </v-col>
                                <v-col cols="2" class="s-col-form">
                                    <s-select-definition
                                        label="Estado"
                                        :def="1554"
                                        v-model="props.item.PjtStatus">
                                    </s-select-definition>
                                </v-col>
							</v-row>
						</v-container>
					</template>

                    <template v-slot:PjtStatusName="{ row }">
						<v-chip
                            dark
                            x-small
                            :color="row.PjtStatusColor">
                            {{ row.PjtStatusName }}
                        </v-chip>
					</template>
				</s-crud>
			</v-col>
		</v-row>
	</div>
</template>
<script>
	import _sService from "../../../services/Technicalassistance/TasProjectionsService";
    import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
    import _sGeneral from "@/services/HelperService.js";
    import SSelectSupervice from "@/components/HarvestSchedule/SSelectSupervice";

	export default {
		components: {
            SSearchLotByCodSenasa,
            SSelectSupervice
        },
        props: {},
		data: () => ({
            item: {},
            filter: {},
            week: null,
            year: null,
			config: {
				model: {
					PjtID: "ID"
				},
				service: _sService,
				headers: [
					{ text: "ID", value: "PjtID" },
					{ text: "ID Lote", value: "FltID" },
					{ text: "Nombre de Fundo", value: "FagName" },
					{ text: "Supervisor", value: "Supervice" },
					{ text: "Semana", value: "PdsName" },
					{ text: "Campaña", value: "CmpName" },
					{ text: "Cantidad Jabas", value: "PjtQuantity" },
					{ text: "Estado", value: "PjtStatusName" },
				],
			},
		}),
        created() {
            this.years = this.$fun.getTop5LastYears();
            this.year = this.$fun.getCurrentYear();
        },
		methods: {
			save(item) {
                if (!item.FltID) {
                    this.$fun.alert("Debe seleccionar un Lote", "warning");
                    return;
                }

                if (!this.week) {
                    this.$fun.alert("Debe seleccionar una semana", "warning");
                    return;
                }

                item.PdsID = this.week;

                console.log("item", this.week);

                item.save();
            },
            updateLotInfo(item, lot) {
                item.FltID = lot.FltID;
                item.FltName = lot.FltName;
                item.FagName = lot.FagName;
                item.PrdCardName = lot.PrdCardName;
                item.FltHectares = lot.FltHectares;
            },
            rowSelected(rows) {
                this.week = null;
                if (rows.length > 0) {
                    this.year = rows[0].PdsYear;
                    this.week = rows[0].PdsID;
                }
            },
            addProjection(item) {
                this.year = this.$fun.getCurrentYear();
                this.week = null;
            },
		},
	};
</script>
